
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M234.667 263.019V32c0-5.888-4.779-10.667-10.667-10.667-123.52 0-224 110.059-224 245.333S110.059 512 245.333 512c60.523 0 93.269-10.965 134.784-45.099 4.459-3.669 5.184-10.219 1.643-14.784L234.667 263.019zm10.666 227.648c-123.52 0-224-100.48-224-224 0-119.552 85.184-217.536 192-223.701v223.701c0 2.368.789 4.672 2.261 6.549l142.848 183.659c-33.685 25.728-61.781 33.792-113.109 33.792z"}}),_c('path',{attrs:{"d":"M266.667 256h234.667c5.888 0 10.667-4.779 10.667-10.667C512 110.059 401.941 0 266.667 0 260.779 0 256 4.779 256 10.667v234.667c0 5.887 4.779 10.666 10.667 10.666zm10.666-234.411c115.051 5.419 207.659 98.027 213.077 213.077H277.333V21.589zM501.333 277.333H288a10.711 10.711 0 00-9.643 6.08 10.641 10.641 0 001.344 11.285l138.667 171.669c1.856 2.325 4.587 3.733 7.552 3.947.256.021.491.021.747.021 2.688 0 5.291-1.024 7.275-2.859C483.541 421.205 512 355.797 512 288c0-5.888-4.779-10.667-10.667-10.667zm-73.749 166.486L310.336 298.667h180.075c-2.624 54.229-25.067 106.09-62.827 145.152z"}})])
          )
        }
      }
    